import * as SignalR from '@aspnet/signalr';
import { Dispatch } from 'redux';

export default class SignalRHandler {
    // to dispatch in below code, do this
    // SignalRHandler.dispatch(actionCreators.showGlobalSearch());
    static dispatch: Dispatch;

    static initialize = (dispatch: Dispatch) => {
        SignalRHandler.dispatch = dispatch;
    };

    static Configure(connectionUrl: string, jwt: string) {
        const messagingConnection = new SignalR.HubConnectionBuilder().withUrl(connectionUrl, { accessTokenFactory: () => jwt }).build();

        messagingConnection.stop();

        messagingConnection.on('send', (data) => {
            console.log(data);
        });

        messagingConnection.on('AssignTask', (data) => {
            console.log(data);
        });

        messagingConnection.onclose(() => {
            // TODO: implement reconnect functionality;
            console.log('connection closed');
        });

        messagingConnection.start().catch((err) => console.log(err));
    }
}



// WEBPACK FOOTER //
// ./src/messaging/SignalRHandler.ts